import React from "react";
import { OrdersRegister } from "./OrdersRegister";
import { sNewOrder } from "../../constants/strings";
import { OrderForm } from "../../forms/OrderForm";
import { CreateDrawer } from "../../components/drawer/DrawerComponent";

export const Orders = () => {
  return (
    <div>
      <CreateDrawer title={sNewOrder} form={<OrderForm />} />
      <OrdersRegister />
    </div>
  );
};
